export class OrganizationContactStatusApi {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * @returns OrganizationContactStatus
     * @throws ApiError
     */
    create({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/organization/{organizationId}/contact-status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns OrganizationContactStatus
     * @throws ApiError
     */
    findByOrganization() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/organization/{organizationId}/contact-status',
        });
    }
    /**
     * @returns OrganizationContactStatus
     * @throws ApiError
     */
    update({ id, requestBody, }) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/organization/{organizationId}/contact-status/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    delete({ id, }) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/organization/{organizationId}/contact-status/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    bulkAssign({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/organization/{organizationId}/contact-status/bulk-assign',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    bulkUnassign({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/organization/{organizationId}/contact-status/bulk-unassign',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    unassign({ requestBody, }) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/organization/{organizationId}/contact-status/unassign',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
